import { render, staticRenderFns } from "./SocialFloating.vue?vue&type=template&id=ebd8fed4&"
import script from "./SocialFloating.vue?vue&type=script&lang=js&"
export * from "./SocialFloating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports